/**
 * TODO: This regex does not support all phone number formats from every country.
 *       Either use a more generic regex or add multiple regexes for different countries.
 *       Changes to the UI input fields will also be needed as it assumes the same format there.
 *
 * Breakdown of regex:
 *   (\+\d*)?                - Optional country code
 *   (-|\s)?                 - Optional hyphen or space in between
 *   \(?(?<area>\d{1,3})\)?  - Area code with optional parentheses surrounding it, placed in a group named "area"
 *   (-|\s)?                 - Optional hyphen or space in between
 *   (?<part1>\d{1,3})?      - Part 1 of the phone number (prefix), placed in a group named "part1".
 *                             Optional to match partially filled in phone numbers.
 *   (-|\s)?                 - Optional hyphen or space in between
 *   (?<part2>\d{1,4})?      - Part 2 of the phone number (line number), placed in a group named "part2"
 *                             Optional to match partially filled in phone numbers.
 */
export const phoneNumberRegex =
  /^(\+\d*)?(-|\s)?\(?(?<area>\d{1,3})\)?(-|\s)?(?<part1>\d{1,3})?(-|\s)?(?<part2>\d{1,4})?$/;

/**
 * Return True if `phoneNumber` looks like a phone number which means the user
 * might be searching a phone number.
 */
export default function isPhoneNumber(phoneNumber) {
  return phoneNumberRegex.test(phoneNumber);
}
